import { Either, Left, Right } from 'fp-ts/lib/Either'

import { log } from '@/log'
import { ApiClient, ApiClientWithAuth } from './client'
import { SessionApiErrorResponse } from './session/response'

const namespace = 'session-api'

export class SessionApiService {
  constructor(
    private readonly apiClient: typeof ApiClient = ApiClient,
    private readonly apiClientWithAuth: typeof ApiClientWithAuth = ApiClientWithAuth
  ) {}

  /**
   * セッションの新規作成
   */
  async new(context: CreateNewSessionContext): Promise<Either<SessionApiErrorResponse, undefined>> {
    try {
      const response = await this.apiClient.post('/api/user/session/new', {
        is_hl_app: context.isHlApp,
      })

      log.debug({ service: `${namespace}/new`, response })

      return new Right(undefined)
    } catch (error) {
      log.error({ service: `${namespace}/new`, error })
      const response = (error as any).response

      return new Left(response
        ? SessionApiErrorResponse.fromResponse(response)
        : SessionApiErrorResponse.fromString(error instanceof Error ? error.message : String(error))
      )
    }
  }

  /**
   * 現在のセッションの延長
   */
  async keepCurrent(): Promise<Either<SessionApiErrorResponse, undefined>> {
    try {
      const response = await this.apiClient.put('/api/user/session/current/keep')

      log.debug({ service: `${namespace}/keepCurrent`, response })

      return new Right(undefined)
    } catch (error) {
      log.error({ service: `${namespace}/keepCurrent`, error })
      const response = (error as any).response

      return new Left(response
        ? SessionApiErrorResponse.fromResponse(response)
        : SessionApiErrorResponse.fromString(error instanceof Error ? error.message : String(error))
      )
    }
  }

  /**
   * セッションデータを更新する
   */
  async loadData(): Promise<Either<SessionApiErrorResponse, undefined>> {
    try {
      const response = await this.apiClientWithAuth.put('/api/user/session/current/data')

      log.debug({ service: `${namespace}/loadData`, response })

      return new Right(undefined)
    } catch (error) {
      log.error({ service: `${namespace}/loadData`, error })
      const response = (error as any).response

      return new Left(response
        ? SessionApiErrorResponse.fromResponse(response)
        : SessionApiErrorResponse.fromString(error instanceof Error ? error.message : String(error))
      )
    }
  }
}

export interface CreateNewSessionContext {
  isHlApp: boolean
}
